import React, { useState, useEffect } from 'react';
import {
  Outlet,
  useMatches,
  useNavigate
} from "react-router-dom";
import {
  Button,
  Col,
  Container,
  Nav,
  Navbar,
  Offcanvas,
} from 'react-bootstrap';
import _ from "lodash";

import { 
  HiClipboardList,
  HiDotsCircleHorizontal,
  HiOutlineChevronLeft,
  HiLogout
} from "react-icons/hi";

import useUser from '../hooks/useUser';
import LogoutAction from '../actions/LogoutAction';

import logo from '../images/repcaster_logo_txt.png';

export default function Dashboard() {
  const navigate = useNavigate();
  const routerMatches = useMatches();
  const { user } = useUser();

  useEffect(() => {
    if(!user) {
      navigate("/");
    }
  });

  const logout = (e) => {
    e.preventDefault();
    LogoutAction();
    navigate("/", { state: { action: "logout" } });
  }  
  const pageName = () => {
    let page = routerMatches[routerMatches.length-1]['pathname'].split('/').reverse().find((val) => val !== "" && isNaN(val))
    if (page === "merchant" || page === "dashboard") return "dashboard";
    return page;
  }

  const displayBackArrow = pageName() === "dashboard" ? false : true;

  return (
    <Container fluid className="d-flex flex-column g-0">
      <Navbar bg="light" expand="false" className="mb-3 fixed-top">
        <Container fluid>
          <Col xs={10} className="text-start">
            { displayBackArrow && 
              <Button onClick={() => navigate(-1)} variant="link" className="px-0 back-button text-decoration-none">
                <HiOutlineChevronLeft className="icon" />
              </Button>
            }
            <Navbar.Brand className="mx-0"><img src={logo} className="nav-logo" alt="logo" /></Navbar.Brand>
          </Col>
          <Col xs={2} sm={1} className="text-end">
            <Navbar.Toggle aria-controls="offcanvasNavbar-expand-false" />
            <Navbar.Offcanvas
              id="offcanvasNavbar-expand-false"
              aria-labelledby="offcanvasNavbarLabel-expand-false"
              placement="end"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id="offcanvasNavbarLabel-expand-false"></Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav className="justify-content-end flex-grow-1 pe-3">
                  <Nav.Link href="/merchant" className="text-primary"><HiClipboardList className="toolbar-icon" />Dashboard</Nav.Link>
                  <Nav.Link href="/merchant/account" className="text-primary"><HiDotsCircleHorizontal className="toolbar-icon" />Account</Nav.Link>
                  <hr/>
                  <Nav.Link onClick={logout} className="text-danger"><HiLogout className="toolbar-icon" />Logout</Nav.Link>
                  <Nav.Item className="footer-offcanvas">
                    <small>&copy;{new Date().getFullYear()} Beep. <a href="#">Terms & Conditions</a></small>
                  </Nav.Item>
                </Nav>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Col>
        </Container>
      </Navbar>
      <Container className="content-container">
        <Outlet />
      </Container>
    </Container>
  )
}